import PrimaryButton from "../designSystem/buttons/PrimaryButton";
import PrimaryButtonSmall from "../designSystem/buttons/PrimaryButtonSmall";
import SecondaryButton from "../designSystem/buttons/SecondaryButton";
import SecondaryButtonSmall from "../designSystem/buttons/SecondaryButtonSmall";
import TextButton from "../designSystem/buttons/TextButton";
import SeeMoreButton from "../designSystem/buttons/SeeMoreButton";
import Hero from "../designSystem/Hero";
import SEO from "../designSystem/SEO";
import TertiaryButton from "../designSystem/buttons/TertiaryButton";
import Accordion from "../designSystem/Accordion";
import UsefulTools1 from "../../assets/images/tools_repaymentcalculator.png";
import UsefulTools2 from "../../assets/images/tools_stampduty.png";
import UsefulTools3 from "../../assets/images/tools_firsttimebuyerrs.png";
import UsefulTools4 from "../../assets/images/tools_buytolet.png";
import UsefulTools5 from "../../assets/images/tools_taxguide.png";
import { useNavigate } from "react-router-dom";
import FirstTimeBuyersGuide from "../../assets/files/first_time_buyers_guide.pdf";
import BuyToLetGuide from "../../assets/files/buy_to_let_guide.pdf";
import TaxGuide from "../../assets/files/tax_guide.pdf";
import { ReactComponent as One } from "../../assets/icons/1.svg";
import { ReactComponent as Two } from "../../assets/icons/2.svg";
import { ReactComponent as Three } from "../../assets/icons/3.svg";
import { ReactComponent as Four } from "../../assets/icons/4.svg";
import { ReactComponent as Five } from "../../assets/icons/5.svg";
import { ReactComponent as Six } from "../../assets/icons/6.svg";
import { ReactComponent as Seven } from "../../assets/icons/7.svg";
import { ReactComponent as Eight } from "../../assets/icons/8.svg";

const UsefulToolsPage = () => {
    const navigate = useNavigate();
  return (
    <div>
      <SEO
        title="Useful Mortgage Tools"
        description="Use mortgage repayment and stamp duty calculators, plus downloadable first-time buyer, buy-to-let and tax guides from AK Mortgages."
        path="/useful-tools"
      />
      <Hero
        title={`Plan Your Property Journey with Confidence`}
        subtitle="Useful Tools"
        titleAlign="center"
        subtitleAlign="center"
      >
        <div className="column-center gap-s">
          <div className="content text-primary-1">
            Whether you're buying your first home, moving house, or building a
            property portfolio, having the right information at the right time
            can make all the difference. At AK Mortgages, we’ve created a set of
            simple, easy-to-use tools and guides to help you understand your
            options and plan ahead with confidence.
          </div>
          <div className="content text-primary-1">
            These tools are designed to give you a clearer picture of what you
            can afford, what costs to expect, and how to make informed decisions
            about your property and finances.
          </div>
        </div>
      </Hero>
      <div id="repayment-calculator" className="background-container bg-white">
        <div className="content-container row-reverse gap-xxxxxl">
          <div className="column gap-l">
            <div className="subtitle-semibold  text-primary-2 uppercase">
              repayment Calculator
            </div>
            <h2 className="text-primary-1 uppercase">
              SEE WHAT YOUR MONTHLY PAYMENTS MIGHT LOOK LIKE
            </h2>
            <div className="column gap-m">
              <div className="content text-primary-1">
                Understanding what your monthly mortgage payments could look
                like is an important part of planning your property journey. Our
                mortgage repayment calculator lets you explore different loan
                amounts, mortgage terms, and interest rates to see how they may
                affect your monthly repayments. This can help you:
              </div>
              <div className="content text-primary-1">
                <ul className="content text-primary-1 column gap-m">
                  <li>Estimate your monthly mortgage repayments</li>
                  <li>
                    Compare different loan amounts, interest rates, and mortgage
                    terms
                  </li>
                  <li>Understand what may be affordable for your budget</li>
                  <li>
                    Plan your finances with greater confidence before applying
                    for a mortgage
                  </li>
                </ul>
              </div>
            </div>

            <PrimaryButton
              text="Mortgage repayment calculator"
              onClick={() => navigate("/calculators/mortgage-repayment")}
            />
            <div className="body2 text-primary-1">
              Your home may be repossessed if you do not keep up with repayments
              on your mortgage.
            </div>
          </div>{" "}
          <img
            src={UsefulTools1}
            alt="Mortgage repayment calculator preview"
            className="hero-image"
          />
        </div>
      </div>
      <div
        id="stamp-duty-calculator"
        className="background-container bg-primary-1"
      >
        <div className="content-container row gap-xxxxxl">
          <img
            src={UsefulTools2}
            alt="Stamp duty calculator preview"
            className="hero-image"
          />
          <div className="column gap-l">
            <div className="subtitle-semibold  text-primary-2 uppercase">
              Stamp Duty Calculator
            </div>
            <h3 className="text-white uppercase">
              Estimate Your Purchase Costs
            </h3>
            <div className="column gap-m">
              <div className="content text-white">
                Stamp Duty Land Tax (SDLT) is an important cost to consider when
                buying a property. Our stamp duty calculator helps you estimate
                the property tax you may need to pay when buying a home in the
                UK. It includes:
              </div>
              <div className="content text-white">
                <ul className="content text-white column gap-m">
                  <li>SDLT (England & Northern Ireland)</li>
                  <li>LTT (Wales)</li>
                  <li>LBTT (Scotland)</li>
                </ul>
              </div>
              <div className="content text-white">
                Use the calculator to understand your likely tax costs, budget
                for your purchase, and plan your finances with confidence.
              </div>
            </div>
            <PrimaryButton
              text="stamp duty calculator"
              onClick={() => navigate("/calculators/stamp-duty")}
            />
          </div>
        </div>
      </div>
      <div id="first-time-buyers-guide" className="background-container">
        <div className="content-container row-reverse gap-xxxxxl">
          <div className="column gap-l">
            <div className="column gap-s">
              <div className="subtitle-semibold  text-primary-2 uppercase">
                First-Time Buyers Guide
              </div>
              <h3 className="text-primary-1 uppercase">
                Everything You Need to Get Started
              </h3>
            </div>
            <div className="column gap-m">
              <div className="content text-primary-1">
                Buying your first home is an exciting milestone, but it can also
                feel overwhelming. Our First-Time Buyers Guide provides
                practical advice to help you understand the process and buy with
                confidence. This guide covers:
              </div>
              <div className="content text-primary-1">
                <ul className="content text-primary-1 column gap-m">
                  <li>The home buying process</li>
                  <li>Mortgage options and affordability</li>
                  <li>Deposits and upfront costs</li>
                  <li>Understanding surveys and conveyancing</li>
                  <li>Tips for a smoother first purchase</li>
                </ul>
              </div>
            </div>
            <PrimaryButton
              text="download the FIRST-TIME BUYERS guide"
              onClick={() => window.open(FirstTimeBuyersGuide, "_blank")}
            />
            <div className="body2 text-primary-1">
              Your home may be repossessed if you do not keep up with repayments
              on your mortgage.
            </div>
          </div>{" "}
          <img
            src={UsefulTools3}
            alt="First-time buyers guide preview"
            className="hero-image"
          />
        </div>
      </div>
      <div id="buy-to-let-guide" className="background-container bg-gray-3">
        <div className="content-container row gap-xxxxxl">
          <img
            src={UsefulTools4}
            alt="Buy-to-let guide preview"
            className="hero-image"
          />
          <div className="column gap-l">
            <div className="subtitle-semibold  text-primary-2 uppercase">
              Buy-to-Let Guide
            </div>
            <h3 className="text-primary-1 uppercase">
              A Simple Guide for Property Investors
            </h3>
            <div className="column gap-m">
              <div className="content text-primary-1">
                Whether you're considering your first rental property or
                expanding an existing portfolio, understanding the buy-to-let
                market is essential. Our Buy-to-Let Guide breaks down the key
                things you need to know in a clear and straightforward way,
                helping you make more informed investment decisions. This guide
                includes:
              </div>
              <div className="content text-primary-1">
                <ul className="content text-primary-1 column gap-m">
                  <li>How buy-to-let mortgages work</li>
                  <li>Key costs involved in becoming a landlord</li>
                  <li>Rental yield basics</li>
                  <li>What lenders typically look for</li>
                  <li>Common mistakes to avoid</li>
                </ul>
              </div>
            </div>
            <PrimaryButton text="download the buy-to-let guide" onClick={() => window.open(BuyToLetGuide, "_blank")} />
          </div>{" "}
        </div>
      </div>{" "}
      <div id="tax-guide" className="background-container">
        <div className="content-container row-reverse gap-xxxxxl">
          <div className="column gap-l">
            <div className="column gap-s">
              <div className="subtitle-semibold  text-primary-2 uppercase">
                Tax Guide
              </div>
              <h3 className="text-primary-1 uppercase">
                Understanding Property Tax Basics
              </h3>
            </div>
            <div className="column gap-m">
              <div className="content text-primary-1">
                Property ownership and investment can involve different tax
                considerations depending on your situation. Our Tax Guide is
                designed to give you a simple overview of the key areas you may
                need to be aware of. This guide covers:
              </div>
              <div className="content text-primary-1">
                <ul className="content text-primary-1 column gap-m">
                  <li>Basic property ownership tax considerations</li>
                  <li>Buy-to-let taxation overview</li>
                  <li>Income tax on rental properties</li>
                  <li>Allowable expenses (general guidance)</li>
                  <li>Why professional advice may be beneficial</li>
                </ul>
              </div>
            </div>
            <PrimaryButton
              text="download the tax guide"
              onClick={() => window.open(TaxGuide, "_blank")}
            />
          </div>{" "}
          <img
            src={UsefulTools3}
            alt="Property tax guide preview"
            className="hero-image"
          />
        </div>
      </div>
      <div className="background-container bg-gray-1">
        <div className="content-container column gap-l">
          <div className="column gap-m">
            <div className="subtitle-semibold  text-white uppercase">
              Need Personal Advice?
            </div>
            <div className="column gap-s">
              <div className="content text-white">
                If you’re unsure about your results or want to explore your
                options in more detail, we can help.
              </div>
              <div className="content text-white">
                Book a free, no-obligation consultation with one of our advisers
                to discuss your mortgage plans and get advice tailored
                specifically to you.
              </div>
            </div>
            <PrimaryButton
              text="book a free initial appointment"
              onClick={() =>
                window.open(
                  "https://bookings.cloud.microsoft/bookwithme/user/fa2261725ab84f21bb747357792d358b%40akmortgages.uk?anonymous&ismsaljsauthenabled",
                  "_blank",
                )
              }
            />
          </div>
          <div className="body2 text-white">
            Your home may be repossessed if you do not keep up with repayments
            on your mortgage.
          </div>
        </div>
      </div>
    </div>
  );
};

export default UsefulToolsPage;
